module.exports = __webpack_public_path__ + "static/img/JG.762cb24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/JG.png
// module id = Thiw
// module chunks = 1